import { render, staticRenderFns } from "./sms-price.vue?vue&type=template&id=084f0948&scoped=true&"
import script from "./sms-price.vue?vue&type=script&lang=js&"
export * from "./sms-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f0948",
  null
  
)

export default component.exports